var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"vx-row mt-4"},_vm._l((_vm.fotos),function(foto,index){return _c('div',{key:foto.nomePosicao,staticClass:"vx-col sm:w-1/2 w-full mb-2"},[_c('uploader',{attrs:{"path":_vm.pathUpload,"label":foto.nomePosicao,"imageUrl":foto.nome},on:{"uploaded":function($event){return _vm.onUpload($event, index)}}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }